export function isValidNumber(value: unknown): value is number {
    return typeof value === 'number' && !Number.isNaN(value);
}

/**
 * Converts number to Korean TTS format
 * @param number
 * @returns Korean word for the number
 */
export const convertNumberToKorean = (number: number): string => {
    const koreanNumber: { [key: number]: string } = {
        1: '일',
        2: '이',
        3: '삼',
        4: '사',
    };

    return koreanNumber[number] || number.toString();
};

export const isDefined = <T>(value: T | undefined | null): value is T => {
    return value !== undefined && value !== null;
};
